import { ICombinedUserData } from 'lib/context';
import { checkIfFreemium } from 'lib/utils/functions';
import { NOTIFICATION_TYPES } from './types';

export const getNotificationFilterOptions = (userData: ICombinedUserData) => {
  const isFreemium = checkIfFreemium(userData);

  const vdpField = userData.isVdpAllowed
    ? [
        {
          value: NOTIFICATION_TYPES.PUSHED_TO_VDP,
          label: 'Pushed To VDP',
        },
      ]
    : [];

  const salesField = userData.isAutomotiveSalesRole
    ? [
        {
          value: NOTIFICATION_TYPES.SALES,
          label: 'Test Drive Schedule',
        },
      ]
    : [];

  const serviceField = userData.isAutomotiveServiceRole
    ? [
        {
          value: NOTIFICATION_TYPES.QUOTES,
          label: 'Quote Updates',
        },
      ]
    : [];

  const videoDeletesField =
    userData.customer.videoDeletionAccess === '1'
      ? [
          {
            value: NOTIFICATION_TYPES.VIDEO_DELETE,
            label: 'Video Deletes',
          },
        ]
      : [];

  if (isFreemium) {
    return [
      {
        value: 'ALL',
        label: 'All notifications',
      },
      {
        value: NOTIFICATION_TYPES.VIEW,
        label: 'Video views',
      },
      {
        value: NOTIFICATION_TYPES.EMAIL_NOT_DELIVERED,
        label: 'Video delivery',
      },
    ];
  }

  return [
    {
      value: 'ALL',
      label: 'All notifications',
    },
    {
      value: NOTIFICATION_TYPES.FILES,
      label: 'File sharing',
    },
    {
      value: NOTIFICATION_TYPES.BOARDS,
      label: 'Board sharing',
    },
    {
      value: NOTIFICATION_TYPES.CTA,
      label: 'CTA clicks',
    },
    {
      value: NOTIFICATION_TYPES.VIEW,
      label: 'Video views',
    },
    {
      value: NOTIFICATION_TYPES.EMAIL_NOT_DELIVERED,
      label: 'Video email delivery status',
    },
    {
      value: NOTIFICATION_TYPES.MESSAGES,
      label: 'Messages',
    },
    {
      value: NOTIFICATION_TYPES.REPLY,
      label: 'Video Reply',
    },
    {
      value: NOTIFICATION_TYPES.REACTIONS_COMMENTS,
      label: 'Video Comments and Reactions',
    },
    ...vdpField,
    ...salesField,
    ...serviceField,
    ...videoDeletesField,
    {
      value: NOTIFICATION_TYPES.LIVE,
      label: 'Meetings',
    },
    {
      value: NOTIFICATION_TYPES.REPORTS,
      label: 'Reports',
    },
  ];
};
export const getPreferencesOptions = (userData: ICombinedUserData) => {
  const isFreemium = checkIfFreemium(userData);

  if (isFreemium) {
    return [
      {
        id: 2,
        name: 'Video email delivery status',
        valueEmail: 'videoEmailDeliveryStatusEmail',
        valueInApp: 'videoEmailDeliveryStatusInApp',
      },
      {
        id: 3,
        name: 'Video views',
        valueEmail: NOTIFICATION_EMAILS.VIDEO_VIEW,
        valueInApp: NOTIFICATION_IN_APP.VIDEO_VIEW,
      },
      {
        id: 16,
        name: 'Video email open status',
        valueEmail: NOTIFICATION_EMAILS.EMAIL_OPEN_STATUS,
        valueInApp: NOTIFICATION_IN_APP.EMAIL_OPEN_STATUS,
      },
    ];
  }

  return [
    {
      id: 2,
      name: 'Video email delivery status',
      valueEmail: NOTIFICATION_EMAILS.EMAIL_STATUS,
      valueInApp: NOTIFICATION_IN_APP.EMAIL_STATUS,
    },
    {
      id: 16,
      name: 'Video email open status',
      valueEmail: NOTIFICATION_EMAILS.EMAIL_OPEN_STATUS,
      valueInApp: NOTIFICATION_IN_APP.EMAIL_OPEN_STATUS,
    },
    {
      id: 3,
      name: 'Video views',
      valueEmail: NOTIFICATION_EMAILS.VIDEO_VIEW,
      valueInApp: NOTIFICATION_IN_APP.VIDEO_VIEW,
    },
    {
      id: 9,
      name: 'Video reply',
      valueEmail: NOTIFICATION_EMAILS.VIDEO_REPLY,
      valueInApp: NOTIFICATION_IN_APP.VIDEO_REPLY,
    },
    {
      id: 4,
      name: 'CTA clicks',
      valueEmail: NOTIFICATION_EMAILS.CTAS,
      valueInApp: NOTIFICATION_IN_APP.CTAS,
    },
    {
      id: 5,
      name: 'File sharing',
      valueEmail: NOTIFICATION_EMAILS.FILES,
      valueInApp: NOTIFICATION_IN_APP.FILES,
    },
    {
      id: 6,
      name: 'Board sharing',
      valueEmail: NOTIFICATION_EMAILS.BOARDS,
      valueInApp: NOTIFICATION_IN_APP.BOARDS,
    },
    {
      id: 10,
      name: 'Video Comments and Reactions',
      valueEmail: NOTIFICATION_EMAILS.REACTIONS,
      valueInApp: NOTIFICATION_IN_APP.REACTIONS,
    },
    {
      id: 15,
      name: 'Meetings',
      valueEmail: NOTIFICATION_EMAILS.LIVE,
      valueInApp: NOTIFICATION_IN_APP.LIVE,
    },
  ];
};
export const NOTIFICATION_EMAILS = {
  FILES: 'filesEmail',
  BOARDS: 'boardsEmail',
  QUOTE_UPDATE: 'quoteUpdateEmail',
  REACTIONS: 'reactionsEmail',
  TEST_DRIVE: 'testDriveScheduleEmail',
  VDP: 'pushedToVdpEmail',
  CTAS: 'ctaClicksEmail',
  VIDEO_REPLY: 'videoReplyEmail',
  VIDEO_VIEW: 'videoViewsEmail',
  EMAIL_STATUS: 'videoEmailDeliveryStatusEmail',
  LIVE: 'liveEmail',
  EMAIL_OPEN_STATUS: 'videoEmailOpenStatusEmail',
};
export const NOTIFICATION_IN_APP = {
  FILES: 'filesInApp',
  BOARDS: 'boardsInApp',
  QUOTE_UPDATE: 'quoteUpdateInApp',
  TEST_DRIVE: 'testDriveScheduleInApp',
  REACTIONS: 'reactionsInApp',
  VDP: 'pushedToVdpInApp',
  CTAS: 'ctaClicksInApp',
  VIDEO_REPLY: 'videoReplyInApp',
  VIDEO_VIEW: 'videoViewsInApp',
  EMAIL_STATUS: 'videoEmailDeliveryStatusInApp',
  LIVE: 'liveInApp',
  EMAIL_OPEN_STATUS: 'videoEmailOpenStatusInApp',
};
